import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Odpoveď")
], -1)
const _hoisted_2 = { class: "flex flex-wrap" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex flex-row gap-2 align-items-center mb-2" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "formgrid grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 pt-1" }, [
  /*#__PURE__*/_createElementVNode("em", { class: "text-500" }, "Predmet")
], -1)
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "" }
const _hoisted_13 = ["on:afterEmailSend"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "ml-3 pt-1 pb-1 flex flex-wrap gap-1" }
const _hoisted_16 = { class: "w-10" }
const _hoisted_17 = { class: "text-700 text-base font-medium mb-1" }
const _hoisted_18 = { class: "text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis" }
const _hoisted_19 = { class: "text-400 text-xs" }
const _hoisted_20 = { class: "w-2 align-items-center flex" }
const _hoisted_21 = { class: "ql-formats" }
const _hoisted_22 = { class: "ql-bold" }
const _hoisted_23 = { class: "ql-italic" }
const _hoisted_24 = { class: "ql-underline" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-list",
    value: "ordered"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-list",
    value: "bullet"
  })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("select", { class: "ql-align" }, [
  /*#__PURE__*/_createElementVNode("option", { selected: "" }),
  /*#__PURE__*/_createElementVNode("option", { value: "center" }),
  /*#__PURE__*/_createElementVNode("option", { value: "right" }),
  /*#__PURE__*/_createElementVNode("option", { value: "justify" })
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("select", { class: "ql-size" }, [
  /*#__PURE__*/_createElementVNode("option", { value: "small" }),
  /*#__PURE__*/_createElementVNode("option", { selected: "" }),
  /*#__PURE__*/_createElementVNode("option", { value: "large" }),
  /*#__PURE__*/_createElementVNode("option", { value: "huge" })
], -1)
const _hoisted_28 = { class: "mt-2 flex justify-content-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_PrimevueEditor = _resolveComponent("PrimevueEditor")!
  const _component_PrimevuePanel = _resolveComponent("PrimevuePanel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_PrimevuePanel, { class: "border-solid border-1 surface-border" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    icons: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($options.onSendEmail && $options.onSendEmail(...args)), ["prevent"])),
        name: "emailForm"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input-email w-full",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.subject) = $event)),
                      type: "text",
                      name: "subject",
                      id: "subject"
                    }, null, 512), [
                      [_vModelText, $data.subject]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_FileUpload, {
                  name: "files[]",
                  url: "",
                  multiple: true,
                  maxFileSize: 10000000,
                  customUpload: true,
                  onSelect: $options.onSelectedFiles
                }, {
                  header: _withCtx(({ chooseCallback,clearCallback }) => [
                    _createVNode(_component_PrimevueSelect, {
                      id: "select-att-type",
                      modelValue: this.selectedAttType,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.selectedAttType) = $event)),
                      options: $data.store.attTypes,
                      optionLabel: "name",
                      placeholder: "Pridaj prílohu výberom jej typu",
                      class: "w-10",
                      onChange: ($event: any) => (chooseCallback())
                    }, {
                      value: _withCtx((slotProps) => [
                        (slotProps.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(slotProps.placeholder), 1))
                      ]),
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "options", "onChange"]),
                    _createElementVNode("div", {
                      ref: "emailDiv",
                      "on:afterEmailSend": ($event: any) => (clearCallback())
                    }, null, 40, _hoisted_13)
                  ]),
                  content: _withCtx(({ files, removeFileCallback }) => [
                    (files.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files, (file, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: file.name + file.type + file.size,
                                class: "shadow-2 p-1 flex surface-card w-10rem"
                              }, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, _toDisplayString(this.attTypes[index].name), 1),
                                  _createElementVNode("div", _hoisted_18, _toDisplayString(file.name), 1),
                                  _createElementVNode("div", _hoisted_19, _toDisplayString($options.formattedFileSize(file.size)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_PrimevueButton, {
                                    class: "file-danger",
                                    icon: "pi pi-times",
                                    onClick: ($event: any) => ($options.onRemoveTemplatingFile(file, removeFileCallback, index)),
                                    severity: "danger"
                                  }, null, 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onSelect"])
              ])
            ])
          ])
        ])
      ], 32),
      _createVNode(_component_PrimevueEditor, {
        modelValue: $data.text,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.text) = $event)),
        onTextChange: $options.textChange,
        editorStyle: "height: 10rem",
        class: "mt-2"
      }, {
        toolbar: _withCtx(() => [
          _createElementVNode("span", _hoisted_21, [
            _withDirectives(_createElementVNode("button", _hoisted_22, null, 512), [
              [
                _directive_tooltip,
                'Bold',
                void 0,
                { bottom: true }
              ]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_23, null, 512), [
              [
                _directive_tooltip,
                'Italic',
                void 0,
                { bottom: true }
              ]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_24, null, 512), [
              [
                _directive_tooltip,
                'Underline',
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _hoisted_25,
          _hoisted_26,
          _hoisted_27
        ]),
        _: 1
      }, 8, ["modelValue", "onTextChange"]),
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createVNode(_component_PrimevueButton, {
          onClick: $options.onSendEmail,
          icon: "pi pi-send",
          size: "large",
          label: "Odoslať",
          iconPos: "left",
          style: {"padding":"0.75rem 1.5rem"}
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            { value: 'Zaslanie mailu' },
            void 0,
            { top: true }
          ]
        ])
      ])
    ]),
    _: 1
  }))
}